import { configuredTransportOrigin } from '../../../../shared/config/api-origin';
import { workspaceFetch } from '../../../../shared/platform/business-workspaces';
import { exactPin, pinFields, type MissionTemplateReadPort } from '../consumer/contract';
import { parseMissionTemplateWire } from './mission-template-wire';
export function createLiveMissionTemplateAdapter({
  baseOrigin,
  fetchImpl,
}: {
  readonly baseOrigin: string;
  readonly fetchImpl?: typeof fetch;
}): MissionTemplateReadPort {
  const configured = configuredTransportOrigin(baseOrigin);
  if (!configured && !/^https?:\/\/[^/?#\\\s@]+\/?$/i.test(baseOrigin))
    throw new Error('Root loopback origin required');
  const origin = new URL(configured ?? baseOrigin);
  const parts = origin.hostname.split('.');
  if (
    !configured &&
    !(
      origin.hostname === 'localhost' ||
      origin.hostname === '[::1]' ||
      (parts.length === 4 &&
        parts[0] === '127' &&
        parts.every((part) => /^\d+$/.test(part) && Number(part) <= 255))
    )
  )
    throw new Error('Loopback origin required');
  return {
    async read(input) {
      const query = exactPin(input);
      const url = `${origin.origin}/read-models/versioned-content/exact?${pinFields.map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`).join('&')}`;
      const response = await (fetchImpl ?? workspaceFetch)(url, {
        method: 'GET',
        credentials: 'omit',
        redirect: 'error',
        cache: 'no-store',
      });
      if (response.status !== 200) throw new Error('MissionTemplate HTTP failure');
      if (
        response.headers.get('Content-Type')?.split(';')[0]?.trim().toLowerCase() !==
        'application/json'
      )
        throw new Error('JSON required');
      const value: unknown = await response.json();
      return parseMissionTemplateWire(value, query);
    },
  };
}
